<template>
    <div>
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        <span v-if="$route.name === 'pages'">
                            Pages
                        </span>
                        <span v-if="$route.name !== 'pages'">
                            <router-link :to="{ name: 'pages' }" v-if="$route.name !== 'pages'">
                                Pages
                            </router-link>
                            &rarr;
                            <span v-if="$route.name === 'page'">
                                {{ getPage($route.params.id).name }}
                            </span>
                            <span v-else>
                                New Page
                            </span>
                        </span>
                    </h1>
                </div>
            </div>
        </section>
        <div class="container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'pages',
        data () {
            return {}
        },
        computed: mapGetters(['pages']),
        methods: {
            getPage(id) {
                return this.pages.find(page => page.id === parseInt(id))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Pages.vue?fcbdfb26